import axios from 'axios';
const apiKey = '8544124-80cad9251b009e871eb67cc67';
class PixabayService {
    httpClient;
    constructor() {
        this.httpClient = axios.create({
            baseURL: 'https://pixabay.com/api/'
        });
    }
    async search(searchTerm, page, options) {
        return this.httpClient.get('', {
            params: {
                key: apiKey,
                q: searchTerm,
                page,
                perPage: 30,
                ...options
            }
        });
    }
    async searchVideos(searchTerm, page) {
        return this.httpClient.get('/videos', {
            params: {
                key: apiKey,
                q: searchTerm,
                page,
                perPage: 30
            }
        });
    }
}
export default new PixabayService();
